<script>
import Label from './Label.vue'

export default {
    props: {
        item: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
    },
    components: {
        Label
    },
    data() {
        return {
        };
    },   
    computed: {
    },
    watch: {
    }
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item"/>
        <div class="banner-wrappaer">
            <div class="nhs-111-banner">
                <div class="banner-left">
                    <div class="banner-intro">
                        {{selectedItem.text_one}}
                    </div>
                    <h1 class="banner-title">
                        {{selectedItem.text_two}}
                    </h1>
                    <div class="banner-text">
                        {{selectedItem.text_three}}
                    </div>
                    <div class="banner-buttons">
                        <a href="https://111.nhs.uk/" target="_blank" class="white-button">
                        111.NHS.UK
                        </a>
                    </div>
                </div> 
                <div class="banner-right">
                    <div>
                        <h2 class="banner-text-title">
                            {{selectedItem.text_four}}
                        </h2> 
                        <div class="banner-right-text">
                            <div v-html="selectedItem.text_five"></div>
                        </div>
                    </div> 
                    <div class="banner-icon_positioned">
                        <img src="https://frimley.patientlink.digital/img/nhs111banner/nhs-111-icon.png" alt="banner-icon" class="img">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.banner-wrappaer {
    width: 80%;
}
.nhs-111-banner {
    width: 100%;
    height: 400px;
    background-color: #fff;
    position: relative;
    overflow: hidden;
    z-index: 1;
    display: flex;
}
.nhs-111-banner .banner-left {
    width: 478px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #0271bb;
    position: relative;
    padding: 40px 32px;
}
.nhs-111-banner .banner-intro {
    max-width: 342px;
    padding: 7px 0;
    border-top: 2px solid #fff;
    border-bottom: 2px solid #fff;
    font-weight: 400;
    font-size: 20px;
    line-height: 21px;
    text-align: left;
    letter-spacing: .9px;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 28px;
    transition: .4s linear;
}
.nhs-111-banner .banner-title {
    width: 100%;
    max-width: 370px;
    margin: 0;
    font-weight: 500;
    font-size: 30px;
    line-height: 40px;
    text-align: left;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: white;
}
.nhs-111-banner .banner-text {
    width: 100%;
    max-width: 410px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    color: #fff;
    transition: .4s linear;
    transition-delay: .6s;
}
.nhs-111-banner .banner-buttons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: auto;
    transition: .4s linear;
    transition-delay: .3s;
}
.nhs-111-banner .white-button {
    min-width: 174px;
    display: inline-block;
    padding: 8px 30px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #fff;
    color: #0271bb;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-decoration: none;
    cursor: pointer;
}
.nhs-111-banner .banner-text-title {
    width: 100%;
    margin: 0;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 30px;
    line-height: 40px;
    text-align: left;
    letter-spacing: 2px;
    text-transform: uppercase;
    transition: .4s linear;
    transition-delay: .1s;
    color: #0271bb;
}
.nhs-111-banner .banner-right {
    flex-grow: 1;
    height: 100%;
    padding: 4em;
    position: relative;
}
.nhs-111-banner .banner-right-text {
    width: 100%;
    max-width: 555px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    color: #000;
    transition: .4s linear;
    transition-delay: .6s;
}
.nhs-111-banner .banner-icon_positioned {
    width: 103px;
    height: 60px;
    margin: 0;
    position: absolute;
    right: 30px;
    bottom: 25px;
}
.nhs-111-banner .banner-icon_positioned img {
    width: 100%;
    height: auto;
}
.nhs-111-banner .banner-left::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 0 20px 28px;
    border-color: rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0) #0271bb;
    position: absolute;
    top: 87px;
    right: -28px;
}
</style>